import { selectChatUnreadMessagesCount } from 'features/chat/chatSlice';
import { useSidePanel } from 'features/side-panels/hooks/useSidePanel';
import { useAppSelector } from 'store/hooks';
import { useChat } from 'features/chat/useChat';

export const useChatControl = () => {
  const unreadCount = useAppSelector(selectChatUnreadMessagesCount);

  const { isPanelVisible, togglePanel } = useSidePanel();

  const { chatAvailable } = useChat();

  const toggleChatPanel = () => {
    togglePanel('chat');
  };

  return {
    active: isPanelVisible('chat'),
    togglePanel: toggleChatPanel,
    icon: 'chat',
    unreadCount,
    isFeatureAvailable: chatAvailable,
  };
};
